import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border font-semibold uppercase tracking-[0.08em] transition-colors focus:outline-none focus:ring-2 focus:ring-ring/80 focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        outline: "border-border bg-background text-foreground",
        success: "border-[color-mix(in_srgb,var(--agent-success)_35%,transparent)] bg-[color-mix(in_srgb,var(--agent-success)_10%,transparent)] text-[var(--agent-success)]",
        warning: "border-[color-mix(in_srgb,var(--agent-warning)_35%,transparent)] bg-[color-mix(in_srgb,var(--agent-warning)_10%,transparent)] text-[var(--agent-warning)]",
        destructive: "border-destructive/30 bg-destructive/10 text-destructive",
        muted: "border-border bg-muted/40 text-muted-foreground",
        accent: "border-primary/25 bg-primary/[0.08] text-primary",
      },
      size: {
        sm: "px-2 py-0.5 text-[0.58rem]",
        default: "px-3 py-1 text-[0.6rem]",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

function Badge({
  className,
  variant,
  size,
  ...props
}: React.ComponentProps<"div"> & VariantProps<typeof badgeVariants>) {
  return <div className={cn(badgeVariants({ variant, size }), className)} {...props} />;
}

export { Badge, badgeVariants };
